import "./team-tabs.component";
